import { useSelector } from 'react-redux';
import { getPermissions } from '../../features/redux/sessionSlice';

function Can({ action, children }) {
  const permissions = useSelector(getPermissions);
  return permissions.find((p) => p.action === action) ? <>{children}</> : <></>;
}
export default Can;
